import { SearchObject } from "app/common/Model/SearchObject";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import { exportExcelVoucherItemReport, getVoucherItemRevenueReport, pagingVoucherItemReport } from "app/services/VoucherItemService";
import { VOUCHER_TYPE_VALUE } from "app/common/LocalConst";

export default class VoucherItemReportStore {
  pageVoucherItemReport = null;
  reportData = null;
  openDetailPopup = false;

  intactSearchObject = {
    ...new SearchObject(),
    voucherDateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    voucherDateTo: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    voucherType: VOUCHER_TYPE_VALUE?.Receive
  }

  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject))

  constructor() {
    makeAutoObservable(this);
  }

  handleOpenDetailPopup = async (rowData, currentFormValues, voucherItemRevenueType) => {
    try {
      const selectedDepartment = {
        id: rowData?.departmentId,
        code: rowData?.departmentCode,
        name: rowData?.departmentName
      };

      const newSO = {
        ...this.searchObject,
        ...currentFormValues,
        pageIndex: 1,
        department: selectedDepartment,
        departmentId: selectedDepartment?.id,
        voucherItemRevenueType: voucherItemRevenueType,
        keyword: null
      };

      await this.handleChangeFormSearch(newSO);

      this.openDetailPopup = true;

    }
    catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu, vui lòng thử lại sau");
    }
  }

  handleCloseDetailPopup = () => {
    this.openDetailPopup = false;

    this.getVoucherItemRevenueReport(this?.searchObject);
  }

  getVoucherItemRevenueReport = async (values) => {
    try {
      const listDepId = [];
      if (values?.departments?.length > 0) {
        Array.from(values?.departments)?.forEach(function (department, index) {
          listDepId.push(department?.id);
        })
      }

      const payload = {
        ...this.searchObject,
        ...values,
        listDepId: listDepId
      };

      // console.log("payload", payload);

      const { data } = await getVoucherItemRevenueReport(payload);
      this.reportData = data;

      return data;
    }
    catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu, vui lòng thử lại sau")
    }
  }

  handleChangeFormSearch = async (values) => {
    if (values?.department?.id) {
      values.departmentId = values?.department?.id;
    }
    else {
      values.departmentId = null;
    }

    if (values?.healthCareSv?.id) {
      values.healthCareSvId = values?.healthCareSv?.id;
    }
    else {
      values.healthCareSvId = null;
    }

    if (values?.group?.id) {
      values.groupId = values?.group?.id;
    }
    else {
      values.groupId = null;
    }

    if (values?.patient?.id) {
      values.patientId = values?.patient?.id;
    }
    else {
      values.patientId = null;
    }




    this.searchObject = {
      ...this.searchObject,
      ...values,
    };

    await this.pagingVoucherItemReport();
  }

  pagingVoucherItemReport = async () => {
    try {
      const payload = {
        ...this.searchObject,
        unCompleted: true,
        getAllServiceInTreatment: true,

      };

      const { data } = await pagingVoucherItemReport(payload);
      this.pageVoucherItemReport = data;
    }
    catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  openConfirmExport = false;

  handleOpenConfirmExport = () => {
    this.openConfirmExport = true;
  }

  handleClose = () => {
    this.openConfirmExport = false;
  }

  handleExportExcelVoucherItemReport = async () => {
    toast.info("Yêu cầu đang được xử lý", {
      autoClose: 6666
    });

    try {
      const payload = {
        ...this.searchObject,
        unCompleted: true,
        getAllServiceInTreatment: true,
      };

      const response = await exportExcelVoucherItemReport(payload);

      if (response.status === 200) {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "BAO_CAO_DOANH_THU_CU_MOI.xlsx");

        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "BAO_CAO_DOANH_THU_CU_MOI.xlsx");
        // document.body.appendChild(link);
        // link.click();
        // link.parentNode.removeChild(link);

        toast.success("Xuất danh sách thành công");

      }
      else {
        throw Error();
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
      console.error("Error export excel report:", error);
    }
  };

  resetStore = () => {
    this.pageVoucherItemReport = null;
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));

  }
}



